import reducer from './reducers/Reducer';

import {combineReducers} from 'redux';

export const AppCombineReducers = combineReducers({
  appStates: reducer,
});
